module.exports = __webpack_public_path__ + "e29dfa94c27e1900113e294bf025b533.svg";